import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';

export const Table = styled.table`
  border: 1px solid #dddddd;
  border-radius: 1px;
  border-spacing: 0;
  background: #fff;
  margin-top: 65.5px;
`;
export const TableHead = styled.thead``;
export const TableBody = styled.tbody``;
export const TH = styled.th`
  font-weight: 500;
  font-size: ${pxToRem(12)};
  padding: 10px 12px;
  text-align: left;
  line-height: ${pxToRem(12)};
  color: #999999;
  border-bottom: 1px solid #ddd;
`;
export const TableRow = styled.tr``;

export const TableData = styled.td`
  padding: 10px 12px;
  text-transform: capitalize;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(21)};
  color: #091e42;
  border-bottom: 1px solid #ddd;
`;
